module.exports = __webpack_public_path__ + "img/Weapon_bow_01_mesh.a96340a4.png";